import { render } from "./ClientsView.vue?vue&type=template&id=40bf45dd&scoped=true"
import script from "./ClientsView.vue?vue&type=script&lang=js"
export * from "./ClientsView.vue?vue&type=script&lang=js"

import "./ClientsView.vue?vue&type=style&index=0&id=40bf45dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf45dd"]])

export default __exports__